import React from 'react';
import { ElementMetadataSectionName, IElementDataSectionGlossaryTerms } from 'components/common/element-data/types';
import ElementDataSection from 'components/common/element-data/ElementDataSection';
import GlossaryTerms from 'components/common/element-data/parts/GlossaryTerms';
import useBundleTranslation from 'i18n';
import { getSectionElementMetadataSettings } from 'components/common/element-data/functions';

export default function GlossaryTermsSection(props: IElementDataSectionGlossaryTerms) {
    const { t } = useBundleTranslation(['components/common/element_data']);
    const { settings, ...element } = props;
    const sectionKey: ElementMetadataSectionName = 'glossary_terms';
    const { sectionMetadataOrder } = getSectionElementMetadataSettings(settings, sectionKey);

    return (
        <ElementDataSection title={t(`element_data_section_label.${sectionKey}`)} order={sectionMetadataOrder}>
            <GlossaryTerms {...element} settings={settings} />
        </ElementDataSection>
    );
}
